// Resource hints for optimized loading (idempotent)
export const addResourceHints = () => {
  if (typeof window === 'undefined') return;

  const ensureLink = (rel: string, href: string, attrs: Partial<HTMLLinkElement> = {}) => {
    const existing = Array.from(document.querySelectorAll(`link[rel="${rel}"]`))
      .find(l => (l as HTMLLinkElement).href === href || (l as HTMLLinkElement).getAttribute('href') === href);
    if (existing) return existing as HTMLLinkElement;
    const link = document.createElement('link');
    link.rel = rel as any;
    link.href = href;
    Object.assign(link, attrs);
    document.head.appendChild(link);
    return link;
  };

  // DNS prefetch for external domains
  const dnsPrefetches = [
    'https://fonts.googleapis.com',
    'https://fonts.gstatic.com',
    'https://images.unsplash.com'
  ];
  dnsPrefetches.forEach(domain => ensureLink('dns-prefetch', domain));

  // Preconnect to critical origins
  const preconnects = [
    'https://fonts.gstatic.com',
    'https://images.unsplash.com'
  ];
  preconnects.forEach(origin => ensureLink('preconnect', origin, { crossOrigin: 'anonymous' }));

  // Preload critical fonts
  ensureLink(
    'preload',
    'https://fonts.gstatic.com/s/inter/v12/UcCO3FwrK3iLTeHuS_fvQtMwCp50KnMw2boKoduKmMEVuLyfAZ9hiJ-Ek-_EeA.woff2',
    { as: 'font', type: 'font/woff2', crossOrigin: 'anonymous' }
  );
};